export const defaultWidgetLayouts = {
  articles: {
    lg: {
      x: 0,
      y: 3,
      w: 12,
      h: 8,
    },
  },
  brands: {
    lg: {
      x: 0,
      y: 0,
      w: 12,
      h: 2,
    },
  },
  articlesCount: {
    lg: {
      x: 0,
      y: 0,
      w: 3,
      h: 2,
    },
  },
  productApprovalsCount: {
    lg: {
      x: 0,
      y: 0,
      w: 3,
      h: 2,
    },
  },
  trackSamples: {
    lg: {
      x: 0,
      y: 0,
      w: 4,
      h: 3,
    },
  },
  trackInquiries: {
    lg: {
      x: 0,
      y: 0,
      w: 4,
      h: 3,
    },
  },
  myActiveShipments: {
    lg: {
      x: 0,
      y: 0,
      w: 4,
      h: 3,
    },
  },
  spacer: {
    lg: {
      x: 0,
      y: 0,
      w: 2,
      h: 2,
    },
  },
  productApprovalLeadTime: {
    lg: {
      x: 0,
      y: 0,
      w: 8,
      h: 4,
    },
  },
  productApprovalRatio: {
    lg: {
      x: 0,
      y: 0,
      w: 8,
      h: 4,
    },
  },
  articleProgress: {
    lg: {
      x: 0,
      y: 0,
      w: 8,
      h: 4,
    },
  },
  paLeadTimeDistribution: {
    lg: {
      x: 0,
      y: 0,
      w: 8,
      h: 4,
    },
  },
  supplierCoverageHeatmap: {
    lg: {
      x: 0,
      y: 0,
      w: 8,
      h: 4,
    },
  },
  paRejectionReasons: {
    lg: {
      x: 0,
      y: 0,
      w: 6,
      h: 4,
    },
  },
  trackOffers: {
    lg: {
      x: 0,
      y: 0,
      w: 4,
      h: 3,
    },
  },
};

export const widgetSizeConstraints = {
  articles: {
    minH: 2,
    minW: 3,
    maxH: 8,
  },
  brands: {
    minH: 2,
    minW: 4,
    maxH: 6,
  },
  articlesCount: {
    minH: 2,
    minW: 3,
    maxH: 8,
  },
  productApprovalsCount: {
    minH: 2,
    minW: 3,
    maxH: 8,
  },
  trackSamples: {
    minH: 2,
    minW: 3,
    maxH: 8,
  },
  trackInquiries: {
    minH: 2,
    minW: 3,
    maxH: 8,
  },
  myActiveShipments: {
    minH: 2,
    minW: 3,
    maxH: 8,
  },
  spacer: {
    minH: 1,
    minW: 1,
    maxH: 12,
  },
  productApprovalLeadTime: {
    minH: 3,
    minW: 6,
    maxH: 8,
  },
  productApprovalRatio: {
    minH: 3,
    minW: 6,
    maxH: 8,
  },
  articleProgress: {
    minH: 3,
    minW: 6,
    maxH: 8,
  },
  paLeadTimeDistribution: {
    minH: 3,
    minW: 6,
    maxH: 8,
  },
  supplierCoverageHeatmap: {
    minH: 3,
    minW: 4,
    maxH: 8,
  },
  paRejectionReasons: {
    minH: 3,
    minW: 4,
    maxH: 8,
  },
  trackOffers: {
    minH: 2,
    minW: 3,
    maxH: 8,
  },
};
